export default "__VITE_ASSET__u0kQb7J7__"